import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";

import ExcelTabelaRelatoriosApc from "./_Aux/ExcelTabelaRelatoriosApc";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import ModalHorarioRelatorioAPC from "./_Aux/ModalHorarioRelatorioAPC";
import ModalHorarioRelatorio from "./_Aux/ModalHorarioRelatorio";
import ModalHorariosFrequencias from "./_Aux/ModalHorariosFrequencias";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class ListaRelatorioApc extends Component {
    state = {
        disciplinaId: localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso"),
        periodoId: 0,
        //LOADING
        visibleLoading: false,
        //VIEWER
        visibleViewer: false,
        isModalVisible: false,
        docs: [],
        dates: [],
        empresaId: localStorage.getItem("entidade_id")
    };
        
    exportarPdf = (disciplina, dataEmissao) => {
        if (this.state.disciplinaId > 0 && this.state.empresaId == 3) {
            disciplina = this.state.disciplinaId
        }

        this.getMeses();
        this.setState(
            {
                visibleLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/pdf/exportar-notas-apc",
                    params: {
                        cursoId: disciplina,
                        dataEmissao: moment(dataEmissao).format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        let fileName = `${localStorage.getItem("header_codigo")} ${localStorage.getItem("header_nome")}`;
                        if (localStorage.getItem("disciplina_nome")) fileName = localStorage.getItem("disciplina_nome");

                        this.setState({
                            visibleLoading: false,
                            visibleViewer: true,
                            docs: [{ uri: response.data, fileName }]
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleLoading: false
                        });
                    });
            }
        );
    };

    getMeses = () => {
        axios({
            method: "get",
            url: "/api/aulas-exportar/get-meses",
            params: {
                id: this.state.disciplinaId,
                periodoId: this.state.periodoId
            }
        })
            .then(response => {
                this.setState({
                    dates: response.data.map(e => e.dataHora)
                });
            })
            .catch(() => {});
    };

    toggleModal = () => {
        this.getMeses();
        this.setState(prevState => ({
            isModalVisible: !prevState.isModalVisible
        }));
    };

    render() {
        const {
            //LOADING
            visibleLoading,
            //VIEWER
            visibleViewer,
            docs,
            dates,
            empresaId
        } = this.state;

        return (
            <>
                <div className="container container-body">
                    <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                        <h3 className="titulo-bloco">Resultados</h3>
                        <div className="bloco-opcoes-esquerda">
                            <Link className={`botao-icon-detalhe botao-maior`} to="#" title="Visualizar" onClick={this.toggleModal}>
                                <Icon type="eye" />
                            </Link>
                            <Link
                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/${
                                    localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                                }`}
                                className="botao-secundario botao-secundario-redondo"
                                title="Voltar"
                                style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                            >
                                <Icon type="arrow-left" />
                            </Link>
                        </div>
                    </div>
                    <div className="curso-diario">
                        <ExcelTabelaRelatoriosApc
                            carregarPeriodoId={periodoId => this.setState({ periodoId })}
                            setDisciplinaId={disciplinaId => this.setState({ disciplinaId })}
                        />
                    </div>
                </div>
                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => this.setState({ visibleViewer: false })} />
                <ModalHorarioRelatorioAPC
                    datas={dates}
                    disciplina={this.state.disciplinaId}
                    visible={this.state.isModalVisible}
                    onClose={this.toggleModal}
                    onSelect={(option3, dataEmissao) => {
                        this.exportarPdf(option3, dataEmissao);
                    }}
                />
            </>
        );
    }
}

export default ListaRelatorioApc;
